import styled, { useTheme } from 'styled-components';
import ApplePayIcon from '../../assets/icons/applepay.svg?react';
import { BeatLoader } from 'react-spinners';
import { hapticsImpactLight } from '../../common/haptic';

const ButtonContainer = styled.div`
  display: flex;
  height: 48px;
  width: 100%;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.text.title};
  border-radius: 999px;
  color: ${({ theme }) => theme.background.primary};
  margin-bottom: 8px;
  margin-top: 8px;
`;

const ApplePayButton = ({ onClick, loading = false }) => {
  const theme = useTheme();
  return (
    <ButtonContainer
      onClick={() => {
        if (loading) return;
        hapticsImpactLight();
        onClick();
      }}
    >
      {loading ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <BeatLoader color={theme.background.primary} size={8} margin={2} />
        </div>
      ) : (
        <ApplePayIcon height='45%' />
      )}
    </ButtonContainer>
  );
};

export default ApplePayButton;
